import React from 'react'

const Footer = () => {
  return (
    <div>
        <div className='footer'>
            <span>Made with 🤍 by Varsha Gupta </span>
        </div>
    </div>
  )
}

export default Footer